import { BaseEntity } from "./BaseEntity";
import { InternshipSchedule } from "./InternshipSchedule";
import { TimesheetType } from "./TimesheetType";
import { User } from "./User";

export class Timesheet extends BaseEntity {
    public date: Date | null | string = "";
    public startTime: Date | null | string = "";
    public endTime: Date | null | string = "";
    public comment: string | null = "";
    public isValidated: boolean = false;
    public timesheetType: TimesheetType | string = "";
    public user: User | string = "";
    public internshipSchedule: InternshipSchedule | string = "";
    public timesheetIds: number[] = [];

    constructor(model: Partial<Timesheet> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PTimesheet = Partial<Timesheet>;
